"use client";

import HomePage from "./home/page";

export default function RootPage() {
  return <HomePage />;
}
